import { render, staticRenderFns } from "./CalendarColorsSettings.vue?vue&type=template&id=b4d08e14"
import script from "./CalendarColorsSettings.vue?vue&type=script&lang=js"
export * from "./CalendarColorsSettings.vue?vue&type=script&lang=js"
import style0 from "./CalendarColorsSettings.vue?vue&type=style&index=0&id=b4d08e14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports